import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from '../services/AuthService';
import Login from './Login';
import Home from './Home';
import Gerenciar from './Gerenciar';
import Incentivar from './Incentivar';
import Cadastro from './CadastraEmpresa';
import Chat from './Chat';
import './App.css';

class App extends Component {
	state ={
		token: null,
		Auth: new AuthService()
	}

	setToken = (token) => {
		console.log(token)
		this.setState({token})
	}

	render() {
		const {Auth} = this.state

		if(this.state.token == true){
			if(this.state.Auth.getToken() && window.location.pathname === "/login"){
				return <Redirect to="/home"/>
			}
		}

		return (

			<div>
				
				<Route exact path="/" render={() => {return(<Redirect to="/home" />)}}/>
				<Route exact path="/gerenciar" render={ () => { return (Auth.isAuthenticated() ? ( <Gerenciar /> ) : ( <Redirect to="/login" /> )) } } />
				<Route exact path="/incentivar" render={ () => { return (Auth.isAuthenticated() ? ( <Incentivar /> ) : ( <Redirect to="/login" /> )) } } />
				<Route exact path="/chat" render={ () => { return (Auth.isAuthenticated() ? ( <Chat /> ) : ( <Redirect to="/login" /> )) } } />
				<Route exact path="/login" render={ () => { return (Auth.isAuthenticated() ? ( <Redirect to="/home" /> ) : ( <Login token={this.setToken} /> )) } } />
				<Route exact path="/Cadastro" render={() => {return <Cadastro/>}} />
				<Route path="/home" render={ () => { return (Auth.isAuthenticated() ? ( <Home /> ) : ( <Redirect to="/login" /> )) } } />				
			
			</div>

		);

	}
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js